import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Common } from '../lib/common-methods';
import { CustomerType } from '../model/customer';
import { ReservationTagCategory } from '../model/reservation-tag';
import { TagType } from '../model/tag-type';
import { BatchCategoryUpdate, CategoryTagDTO, TagsRootDTO } from '../model/tags.dto';

@Injectable({
  providedIn: 'root'
})
export class TagsApiService {

  private baseUrl = `${environment.apiUrl}/tags`;

  constructor(
    private httpClient: HttpClient,
    private translate: TranslateService,
    private store: Store<{}>) {

  }

  getAllTags(restaurantId: number | string): Observable<TagsRootDTO> {
    restaurantId = restaurantId.toString();
    return this.httpClient.get<TagsRootDTO>(`${this.baseUrl}/${restaurantId}`).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  saveTags(dto: BatchCategoryUpdate): Observable<TagsRootDTO> {
    for (let cat of dto.batchUpdateTagCategories) {
      for (let tag of cat.tags) {
        tag.timeperformed = new Date().getTime();
      }
    }
    return this.httpClient.post<TagsRootDTO>(`${this.baseUrl}/batchUpdate`, dto).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getTagCategories(restaurantId: number | string, type?: TagType | undefined): Observable<ReservationTagCategory[] | null> {
    restaurantId = restaurantId.toString();
    return this.httpClient.get<TagsRootDTO>(`${this.baseUrl}/${restaurantId}`).pipe(
      map((res: TagsRootDTO) => {
        if (res.ErrorCode != null && res.ErrorCode.length > 0) {
          return null;
        }
        return res.categories
          .sort((a, b) => {
            if (ReservationTagCategory.isCatDtoDietary(a)) {
              return -1;
            } else if (ReservationTagCategory.isCatDtoDietary(b)) {
              return 1;
            }
            return a.categoryOrder - b.categoryOrder;
          })
          .filter(r => type == null || r.categoryType == type)
          .map(a => Common.reservationCategoryDTOtoModel(a)) ?? [];
      })
    );
  }

  getAllCategories(restaurantId: number | string): Observable<ReservationTagCategory[] | null> {
    return this.getTagCategories(restaurantId);
  }

  getResevrationCategories(restaurantId: number | string): Observable<ReservationTagCategory[] | null> {
    return this.getTagCategories(restaurantId, "RESERVATION");
  }

  getCustomerTags(restaurantId: number | string): Observable<ReservationTagCategory[] | null> {
    return this.getTagCategories(restaurantId, "CUSTOMER");
  }

}
